module.exports = __webpack_public_path__ + "resources/icon-check.0899d8802bb08d66.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-comment/img/icon-check.png
// module id = 704
// module chunks = 0 1 2